export const FETCH_DFLIST_BEGIN = 'FETCH_DFLIST_BEGIN';
export const FETCH_DFLIST_SUCCESS = 'FETCH_DFLIST_SUCCESS';
export const FETCH_DFLIST_ERROR = 'FETCH_DFLIST_ERROR';